import React, { Component } from 'react';
import AddStudents from '../pages/AddStudents';

class AddStudentsPage extends Component {
  render() {
    return (
      <div className="content">
        <AddStudents />
      </div>
    );
  }
}

export default AddStudentsPage;
